<input
  class="currency-input"
  [class.form-error-border]="error"
  type="text"
  inputmode="decimal"
  autocomplete="off"
  [attr.id]="controlId"
  [maskito]="mask"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (input)="handleInput($event)"
  (blur)="handleBlur()" />
